import React from 'react';
import PropTypes from 'prop-types';

class GenerateReferralButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptedTos: false,
    };
  }

  /* istanbul ignore next */
  render() {
    const { submitting, handleGenerateCode } = this.props;
    const { acceptedTos } = this.state;

    return (
      <div>
        <p>
          Generate a reward code for yourself to get started!
        </p>
        <p>
          <small>
            <i>
              Please remember that your referral code is exclusively for
              {' '}
              <b>sharing with new customers</b>
              , and cannot be applied to future orders for your organization.
              {' '}
              We appreciate your cooperation.
            </i>
          </small>
        </p>
        <p>
          <input
            type="checkbox"
            checked={acceptedTos}
            onChange={() => {
              this.setState(
                { acceptedTos: !acceptedTos },
              );
            }}
          />
          {' '}
          I agree to the Referral Program
          {' '}
          <a href="/terms/referral-program" target="_blank">Terms of Service</a>
        </p>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleGenerateCode}
          disabled={submitting || !acceptedTos}
        >
          {submitting ? 'Generating Code...' : 'Generate Code'}
        </button>
      </div>
    );
  }
}

GenerateReferralButton.propTypes = {
  submitting: PropTypes.bool.isRequired,
  handleGenerateCode: PropTypes.func.isRequired,
};

export default GenerateReferralButton;
